<template>
    <div class="addtask">
        <h2>新增学习任务</h2>
        <el-main class="addtaskcom">
            <h4>基本信息</h4>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="addtaskForm">
            <el-form-item label="任务名称:" prop="title">
                <el-input v-model="ruleForm.title" class="ruleInput"></el-input>
            </el-form-item>
                <el-form-item prop="timeDate" label="有效期:">
                    <el-date-picker
                    v-model="ruleForm.timeDate"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form-item>
            <h4>阶段任务</h4>
            <div class="addstage">
                <div class="stageTop">阶段一</div>
                <div class="stageCom">
                    <div class="stageCom_top">
                        <em class="lf">学习任务</em>
                        <div class="stageCom_btn rf">
                            <el-button @click="openCourseware = true"><i class="el-icon-plus"></i>课件</el-button>
                            <el-button @click="dialogAdd = true"><i class="el-icon-plus"></i>考试</el-button>
                            <el-button><i class="el-icon-plus"></i>问卷</el-button>
                        </div>
                    </div>
                    <div class="stageCom_txt" v-for="(item,ix) in learingList" :key="ix">
                        <img src="/static/img/learing.png" class="lf"><span class="lf">{{item.name}}</span><span class="rf learingDelete" @click="del(1)">删除</span>
                    </div>
                    <div class="stageCom_top">
                        <em class="lf">考试任务</em>
                    </div>
                    <div class="stageCom_txt" v-for="(item,ix) in examList" :key="ix">
                        <img src="/static/img/exam.png" class="lf"><span class="lf">{{item.name}}</span><span class="rf learingDelete" @click="del(2)">删除</span>
                    </div>
                </div>
            </div>
            <el-form-item label="指派范围:" class="scope_addtask" >
                <div class="scope_wra rf" @click="addView(2)" >
                    <el-radio  class="rf radion_addtask"  v-model="ruleForm.scope" label="1" >部门/学员</el-radio>
                </div>
            </el-form-item>
            <h4>设置</h4>
             <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>合格标准</p><span>【必填】达到设置的值后才算合格</span>
                </div>
                <div class="option_com">
                    <el-checkbox-group v-model="ruleForm.checkList" @change="checkchangePass">
                        <div class="check_addtask"><el-checkbox label="1">合格奖励(分)</el-checkbox><el-input v-model="ruleForm.pscore" class="check_input" :disabled="progress"></el-input><span class="ts_addtask">在规定时间内，学员学习进度需要达到值</span></div>
                        <div class="check_addtask"><el-checkbox label="2">不合格扣除(分)</el-checkbox><el-input v-model="ruleForm.lscore" class="check_input" :disabled="passin"></el-input><span class="ts_addtask">考试需要达到的及格场数</span></div>
                    </el-checkbox-group>
                </div>
            </el-form-item>
             <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>监督人(1)</p><span>创建人为默认监督人</span>
                </div>
                <div class="option_com">
                    <span class="monitorPeo lf" v-for="(item,ix) in adminList" :key="ix">{{item.title}}</span>
                    <el-button type="button" class="lf monitorPeo_btn" @click="addView(3)"><i class="el-icon-plus"></i>添加监督人</el-button>
                    <div class="clear"></div>
                    <el-checkbox v-model="monitor">监督人协同阅卷</el-checkbox>
                </div>
            </el-form-item>
            <div class="addstaskUp">
                <el-button type="primary" @click="submitRule('ruleForm')">保存</el-button>
                <el-button @click="hrefTo">返回</el-button>
            </div>
            <dialogFw :addCourseware.sync='addCourseware'  ></dialogFw>
        </el-form>
        </el-main>
     <el-dialog title="选择课件" :visible.sync="openCourseware" custom-class="dialogFw dialogKj">
        <div class="ViewDialog_ExamWrap">
            <div class="ViewDialog_views ViewDialog_learlf lf">
                <h6 style="color:#55ACEF;padding-left:10px;margin-bottom:16px;">全部</h6>
                <el-tree :data="data" :props="exampProps"  @node-click="examCla"></el-tree>
            </div> 
            <div class="ViewDialog_Exams ViewDialog_learing lf">
                <h6>全部</h6>
                <el-input placeholder="请输入内容" v-model="FwSearch" class="learningSear"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>  
                <div class="clear"></div>
                <ul>
                    <li v-for="(item,index) in treeExam" class="leadringRadio" :key="index"  v-if="item.sec_type==5">
                        <el-radio-group v-model="examRadio" >
                            <el-radio :label="item.sec_name" :key="index" :data-id="item.sec_id" ref="learingtree">
                            <img src="/static/img/learing.png" class="lf"><span class="lf">{{item.sec_name}}</span>
                            </el-radio>
                        </el-radio-group>
                    </li>
                    <li v-else class="leadringRadio nchecklist" @click="nextfile(item.res,item.sec_id)">
                        <img src="/static/img/learing.png" class="lf"><span class="lf">{{item.sec_name}}</span>
                    </li>
                </ul>
                <page :count="count" :Page.sync='page' :limitrue.sync='limitrue' @pagenation='pagetree' v-if="limitrue==true"></page>
            </div>
            <div class="clear"></div>
            <div class="ViewDiaolog_Btn">
                <el-button type="primary" @click="Uptree">保存</el-button>
                <el-button @click="openPaperDialog=false">取消</el-button>
            </div>
        </div>
    </el-dialog>    
    <el-dialog title="新建考试" :visible.sync="dialogAdd" custom-class="dialogFw">
        <el-main class="addtaskcom">
            <h4>选择试卷</h4>
            <el-form :model="examForm" :rules="addexam" ref="examForm" label-width="100px" class="addtaskForm">
            <el-form-item label="试卷模式:" prop="resource">
                <el-radio-group v-model="examForm.resource" class="raido_task">
                    <el-radio label="1">固定试卷</el-radio>
                    <el-radio label="2">随机试卷</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="选择试卷:" prop="taskexam">
                <el-input v-model="examForm.taskexam" class="ruleInput" :disabled="true"></el-input>
                <el-button type="text" @click="addView(1)" ><i class="el-icon-plus"></i>选择试卷</el-button>
            </el-form-item>
            <el-form-item label="及格线:" prop="pogenum">
                <el-input-number v-model="examForm.pogenum" controls-position="right"  :min="1" :max="100"></el-input-number>
                <span>%</span>
            </el-form-item>
            <el-form-item label="考试时长:" prop="num">
                <el-input-number v-model="examForm.num" controls-position="right"  :min="0" :max="300"></el-input-number>
                <span>分钟</span>
            </el-form-item>
            <el-form-item  class="option_addtask" label-width="0" >
                <div class="option_top">
                    <p >防作弊</p>
                </div>
                <div class="option_com">
                    <el-switch
                        v-model="examForm.cheat"
                        class="switch_addtask lf"
                        active-text="防作弊">
                    </el-switch>
                    <span class="ts_addtask lf">开启后试题顺序会随机打乱</span>
                </div>
            </el-form-item>
            <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>重考设置</p>
                </div>
                <div class="option_com">
                    <el-switch
                        v-model="examForm.reexamination"
                        class="switch_addtask lf"
                        @change="handchange"
                        active-text="允许重复考试">
                    </el-switch>
                    <span class="ts_addtask lf">开启后试题顺序会随机打乱</span>
                    <div class="clear"></div>
                        <el-radio-group v-model="examForm.retake" class="raido_task reexamradio" v-if="reexam">
                            <el-radio label="1">学员及格后完成重考</el-radio>
                            <el-radio label="2">考试结束前无限制重考</el-radio>
                        </el-radio-group>
                        <el-radio-group v-model="examForm.record" class="raido_task reexamradio" v-if="reexam">
                            <el-radio label="1">记录学员最新成绩</el-radio>
                            <el-radio label="2">记录学员最高成绩</el-radio>
                        </el-radio-group>
                        <el-radio-group v-model="examForm.reexamradio" class="raido_task reexamradio">
                            <el-radio label="1">交卷后可查看答案和解析</el-radio>
                            <el-radio label="2">不允许查看答案和解析</el-radio>
                            <el-radio label="3">考试结束后可查看答案和解析</el-radio>
                        </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>阅卷方式</p>
                </div>
                <div class="option_com">
                    <el-radio-group v-model="examForm.reexammark" class="raido_task reexamradio">
                        <el-radio label="1" class="lf">系统阅卷<span class="reexam_addtask">开启后试题顺序会随机打乱</span></el-radio>
                        <el-radio label="2" class="lf">人工阅卷<span class="reexam_addtask">开启后试题顺序会随机打乱</span></el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
        
        </el-form>
        </el-main>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('examForm')" >保存</el-button>
            <el-button type="primary" @click=" dialogAdd = false">取消</el-button>
        </div>
    </el-dialog>
    <dialogFw :addViewExam.sync='addViewExam' :visible.sync='visible' @examViews='examViewsTxt'  :bmid.sync="bmid"  @bmidfw='bmidfwtxt'></dialogFw>
    </div>
</template>

<script>
import dialogFw from '../Common/dialog'

export default{
    name:'addlearning',
   data(){
        var validDate = (rule,value,callback) => {    
            if(value){  
                if(!value[0] || !value[1]){
                callback(new Error("请选择有效时6间"))
                }else{
                callback()
                }
            }
            else{
                callback(new Error("请选择有效时6间"))
            }
        };
       return{
           certin:true,
           adminList:[],
           stime:'',
           passin:true,
           progress:true,
           dialogAdd:false,
           bmid:0,
           examList:[],
           addCourseware:false,
           addViewExam:false,
           FwSearch:'',
           treeExam:[],
           visible:false,
           monitor:'',
           limitrue:false,
           examUp:'',
           learingList:[],
           reexam:false,
           dataId:'',
           p_scroe:'',
           data:[],

           isColl:'',
           openCourseware:false,
           examRadio:'',
            ruleForm: {
                title: '',
                timeDate:'',
                pscore:'',
                admin:[],
                lscore:'',
                examinee:[],
                certificate:'',
                checkList:[],
            },
            rules:{
                title: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' },
                ],
            timeDate:[
                    {validator: validDate, trigger: 'change',required: true,message: '请选择开始和结束时间'}
                ]
            },
            addexam:{
                resource: [
                    { required: true, message: '请选择试卷模式', trigger: 'change' },
                ],
                taskexam: [
                    { required: true, message: '请选择试卷', trigger: 'change' }
                ],
            },
            examForm:{
                resource:'1',
                taskexId:'',
                taskexam:'',
                pogenum:'',
                num:'',
                cheat:'0',
                reexamination:false,
                retake:'1',
                record:'1',
                reexamradio:'1',
                reexammark:'1',
            },
             exampProps:{
                children: 'son',
                label: 'sec_name'
            },
       }
   }, 
   components:{
    dialogFw
  },
   methods:{
        submitForm(formName) {
           this.$refs[formName].validate((valid) => {
               if(valid==true){
                    if(this.examForm.reexamination==true){
                        var retake =this.examForm.retake
                        var record =this.examForm.record
                    }
                    else{
                        var retake =''
                        var record =''
                    }
                    var answerList ={
                        marking:this.examForm.resource,
                        content:this.examForm.taskexId,
                        score:this.p_scroe*this.examForm.pogenum/100,
                        scores:this.p_scroe,
                        time:this.examForm.num,
                        marking:this.examForm.reexammark,
                        parsing:this.examForm.reexamradio,
                        retake:retake,
                        record:record,
                    }
                    this.examUp=answerList
                    var anList=[{name:this.examForm.taskexam}]
                    this.examList=anList
                    this.dialogAdd = false
               }
               else{
                    this.alertView.failView('请填写完全')
               }
               
            });
        },
        submitRule(formName) {
           this.$refs[formName].validate((valid) => {
               if(valid==true){
                    var d = this.ruleForm.timeDate[0]
                    var year = d.getFullYear();
                    var month = d.getMonth() + 1;
                    var date = d.getDate();
                    var datetime = year + '-' + (month > 9?(month + "") : ("0" + month))+ '-' + (date>9?(date + "") : ("0" + date));
                    var end = this.ruleForm.timeDate[1]
                    var endyear = end.getFullYear();
                    var endmonth = end.getMonth() + 1;
                    var enddate = end.getDate();
                    var edatetime = endyear + '-' + (endmonth > 9?(endmonth + "") : ("0" + endmonth))+ '-' + (enddate>9?(enddate + "") : ("0" + enddate));
                    var data={
                        service:'Study.AddTask',
                        title:this.ruleForm.title,
                        s_time:datetime,
                        e_time:edatetime,
                        task:JSON.stringify(this.examUp),
                        examinee:this.ruleForm.examinee,
                        content:this.examForm.taskexId,
                        pscore:this.ruleForm.pscore,
                        lscore:this.ruleForm.lscore,
                        userid:localStorage.getItem('userid')
                    }
                    this.$axios.post(this.HOME,this.$qs.stringify(data))
                        .then(res=>{
                        if(res.data.data.code==0){
                            this.$router.push({path:'/questionIndex'})
                        }
                    })
                }
                else{
                    this.alertView.failView('请把内容填写完全')
                }
        });
        },
        nextfile(len,id){
            if(len===1){
                this.alertView.failView('该目录没有下级内容')
                return false
            }
            var data ={
                service:'Study.File',
                id:id
            }
            var list =[]
             this.$axios.post(this.HOME,this.$qs.stringify(data))
                .then(res=>{
                     for(let i in res.data.data.info){
                        list.push(res.data.data.info[i])
                    }
                    this.treeExam=list
            })
        },
        bmidfwtxt(id,data){
            if(id==1){
                let ids = []
                for(let i in data) {
                    ids.push(data[i].id)
                }
                ids = ids.join(',')
                this.ruleForm.examinee = ids
            }
            else{
                this.ruleForm.admin=data
                this.adminList=data
            }
            console.log(data)
       },
        handchange(e){
           if(e==true){
               this.reexam=true
           }
           else{
               this.reexam=false
           }
       },
        examViewsTxt(value,id,score){
        this.examForm.taskexam=value
        this.examForm.taskexId=id
        this.p_scroe=score
       },
        examCla(node,data){
            var id =node.sec_id
            var list =[]
            var data={
                service:'Study.Folder',
                id:id
            }
            this.$axios.post(this.HOME,this.$qs.stringify(data))
                .then(res=>{
                if(res.data.data.code==0){
                    for(let i in res.data.data.info){
                        list.push(res.data.data.info[i])
                    }
                }
                else{
                    this.alertView.failView('该部门没有课件')
                }
                this.treeExam=list
            })
        },
        addView(type){
           if(type==1){
            this.addViewExam=true
          }
          else if(type==2){
            this.visible=true
            this.bmid=1
          }
          else{
              this.visible=true
              this.bmid=2
          }
      },
      del(id){
          if(id==1){
              this.learingList=[]
          }
          else{
               this.examList=[]
          }
      },
        hrefTo(){
            this.$router.push({ path:'/task'})
        },
        Uptree(){
           for (let i in this.$refs.learingtree){
                if(this.$refs.learingtree[i].$el.ariaChecked =='true'){
                    this.dataId=this.$refs.learingtree[i].$attrs['data-id']
                }
            }
            var list =[{
                id:this.dataId,
                name:this.examRadio
            }]
            this.learingList=list
            this.openCourseware=false
        },
        checkchange(e){
            if(e==true){
                this.certin=false
            }
           else{
               this.certin=true
           }
        },
        checkchangePass(e){
            if(e.indexOf('1')==-1){
               this.progress=true
           }
           else{
               this.progress=false
           }
            if(e.indexOf('2')==-1){
               this.passin=true
           }
           else{
               this.passin=false
           }
        },
   },
   mounted(){
       var data=[]
       this.$axios.post(this.HOME,this.$qs.stringify({service:'Examtask.Admininfo'}))
            .then(res=>{
            for(var i=0;i<res.data.data.length;i++){
                data.push(res.data.data[i])
            }
            this.data=data
        })
   }
}
</script>
<style>
    @import "../../assets/css/task.css";
    @import "../../assets/css/questionnaire.css";
    @import "../../assets/css/examManeger.css";
</style>


// WEBPACK FOOTER //
// src/components/questionnaire/addlearning.vue